<template>
  <div>
    <div class="pagination-box text-right">
      <el-pagination
				@current-change="currentChange"
				:pager-count="5"
        :current-page.sync="pagOption.current"
        :page-size="pagOption.size"
        layout="prev, pager, next, total, jumper"
        :prev-text="'< ' + $t(lang.Previous)"
        :next-text="$t(lang.Next) + ' >'"
        :total="pagOption.total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    pagOption: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      currentPage: this.pagOption.current,
      lang: {
        Next: "ArtworkDetail.Next",
        Previous: "ArtworkDetail.Previous"
      }
    }
  },
	methods: {
		//跳转页面
		currentChange(page) {
		  this.pagOption.current = page;
			console.log(this.$parent)
		  this.$emit('current',page)
		},
	},
  mounted () {

  },
	watch: {
		pagOption(val) {
			this.pagOption.current = val.current;
			this.pagOption.size = val.size;
			this.pagOption.total = val.total;
		}
	}
}
</script>
<style lang="scss" scoped>
  .pagination-box {
    padding: 40PX 0;
    border-top: 1PX solid #ddd;
  }
</style>